var member_contact_form = ( function( $ ) {

	var $form           = $( '.contactMemberForm' );
	var $button         = $( 'a#open-form' );
	var $scroll_trigger = $( '.contactMember' );

	var _init = function() {
		$button.on( 'click', _open_form );
		$scroll_trigger.on ( 'click', _scroll_to_form );
	};

	var _scroll_to_form = function( e ) {
		e.preventDefault();
		$('html, body').animate( { scrollTop:$form.offset().top }, 1000 );
		$button.addClass( 'open' );
	};

	var _open_form = function( e ) {
		e.preventDefault();
		$form.slideToggle();
		$button.toggleClass( 'open' );
	};

	if ( $button.length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = member_contact_form;
